"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Icon = void 0;
var VxtIcon = {
  /* eslint-disable @typescript-eslint/no-empty-function */
  install: function install() {}
};
var Icon = VxtIcon;
exports.Icon = Icon;
var _default = VxtIcon;
exports.default = _default;